export const mockClientItems = (itemsNumber = 100) => {
  const mockItems = [];

  for (let i = 1; i < itemsNumber + 1; i += 1) {
    mockItems.push({
      key: `${i}`,
      AccessLevelName: "Super Admin",
      username: "Yahya Abd Rahman",
      email: "yahya@gmail.com",
      contactNo: "012-345 6789",
      lastUpdated: "2024-10-24 10:45:00",
    });
  }
  return mockItems;
};

export const mockServerItems = async (serverOptions) => {
  const { page, rowsPerPage, sortBy, sortType } = serverOptions;
  const serverItemsLength = 99;
  const serverTotalItems = mockClientItems(serverItemsLength);
  if (sortBy && sortType) {
    serverTotalItems.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return sortType === "desc" ? 1 : -1;
      if (a[sortBy] > b[sortBy]) return sortType === "desc" ? -1 : 1;
      return 0;
    });
  }
  await new Promise((s) => setTimeout(s, 2000));
  return {
    serverCurrentPageItems: serverTotalItems.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    ),
    serverTotalItemsLength: serverItemsLength,
  };
};
